import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// core version + navigation, pagination modules:
import {Swiper, Navigation, Pagination, Thumbs, Autoplay, EffectCards, EffectCoverflow, Controller} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/controller';
import 'swiper/css/autoplay';
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Navigation, Controller, Autoplay],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 16,
        autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: "#heroSwiperPrev",
            prevEl: "#heroSwiperNext",
        },
    });

    let heroSwiper2 = new Swiper("#heroSwiper2", {
        modules: [Controller],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 16,
    });

    heroSwiper.controller.control = heroSwiper2;
    heroSwiper2.controller.control = heroSwiper;

    let categoriesSwiper = new Swiper("#categoriesSwiper", {
        modules: [Navigation],
        slidesPerView: 3,
        loop: true,
        spaceBetween: 16,
        breakpoints: {
            480: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                slidesPerView: 6,
                spaceBetween: 30,

            },
            navigation: {
                nextEl: "#categoriesSwiperPrev",
                prevEl: "#categoriesSwiperNext",
            },
        },
    });


    let specialCategoriesSwiper = new Swiper("#specialCategoriesSwiper", {
        slidesPerView: 1.4,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            480: {
                slidesPerView: 1.7,
            },
            768: {
                slidesPerView: 2.8,
            },
            1024: {
                slidesPerView: 4.6,
            },
            1280: {
                slidesPerView: 4.5,
            },
        },
    });



    let specialCategoriesSwiper2 = new Swiper("#specialCategoriesSwiper2", {
        modules: [Navigation, EffectCoverflow],
        slidesPerView: 1,
        loop: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
        spaceBetween: 20,
        effect: 'coverflow',
        coverflowEffect: {
            rotate: 20,
            stretch: 0,
            depth: 30,
            modifier: 1,
            slideShadows: false,
        },
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 1.5,
            },
            1024: {
                slidesPerView: 3,
            },
            1280: {
                spaceBetween: 20,
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: "#specialCategoriesNext",
            prevEl: "#specialCategoriesPrev",
        },
    });


    let specialCategoriesSwiper3 = new Swiper("#specialCategoriesSwiper3", {
        slidesPerView: 1.4,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            480: {
                slidesPerView: 1.7,
            },
            768: {
                slidesPerView: 2.8,
            },
            1024: {
                slidesPerView: 4.6,
            },
            1280: {
                slidesPerView: 4.5,
            },
        },
    });

    let specialCategoriesSwiper4 = new Swiper("#specialCategoriesSwiper4", {
        slidesPerView: 1.4,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            480: {
                slidesPerView: 1.7,
            },
            768: {
                slidesPerView: 2.8,
            },
            1024: {
                slidesPerView: 4.6,
            },
            1280: {
                slidesPerView: 4.5,
            },
        },
    });


    let blogSwiper = new Swiper("#blogSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        spaceBetween: 20,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.8,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: "#blogSwiperNext",
            prevEl: "#blogSwiperPrev",
        },
    });




    // Navbar scroll
    window.onscroll = fixNavbar;

    function fixNavbar()
    {
        // console.log('scroll y is : ' + window.scrollY);
        var navBar = document.getElementById("navBar");

        if (window.scrollY > 65) {
            navBar.classList.add('navBarFixed');
            navBar.classList.remove('navBarDefault');
        } else {
            navBar.classList.remove('navBarFixed');
            navBar.classList.add('navBarDefault');
        }
    }


    /* BUTTON HOVER */
    const ELEMENTS = document.querySelectorAll(".HOVER");
    const ELEMENTS_SPAN = [];
    const addAnimation = true;
    const ANIMATEDCLASSNAME = "animated-class";

    ELEMENTS.forEach((element, index) => {
        if (!ELEMENTS_SPAN[index])
            ELEMENTS_SPAN[index] = element.querySelector("span");

        element.addEventListener("mouseover", e => {
            const rect = element.getBoundingClientRect();
            ELEMENTS_SPAN[index].style.left = e.clientX - rect.left + "px";
            ELEMENTS_SPAN[index].style.top = e.clientY - rect.top + "px";

            if (addAnimation) element.classList.add(ANIMATEDCLASSNAME);
        });

        element.addEventListener("mouseout", e => {
            const rect = element.getBoundingClientRect();
            ELEMENTS_SPAN[index].style.left = e.clientX - rect.left + "px";
            ELEMENTS_SPAN[index].style.top = e.clientY - rect.top + "px";
        });
    });

    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });
}

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
